const sur = (youData) => {
    youData.health = 0;
    youData.mana = 0;
}

export default sur;